import EDFError from './edf.error';

export default class ConnectionError extends EDFError {
    constructor(message: string, cause?: Error) {
        super(message, 'EDF:ConnectionError', cause);
    }
}
